import { render, staticRenderFns } from "./ScreenLaudoTransvaginalUteroComDoppler.vue?vue&type=template&id=021e88e1&lang=true&"
import script from "./ScreenLaudoTransvaginalUteroComDoppler.vue?vue&type=script&lang=js&"
export * from "./ScreenLaudoTransvaginalUteroComDoppler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports